import { API_ENDPOINTS } from '../constants';
import { SchoolCreateFormData, SchoolUpdateFormData } from '../types';

import { get, post, put, del } from './apiClient';

// Pagination types
export interface PaginationMeta {
  page: number;
  per_page: number;
  total: number;
  pages: number;
  has_next: boolean;
  has_prev: boolean;
  next_page: number | null;
  prev_page: number | null;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: PaginationMeta;
}

export interface School {
  id: number;
  name: string;
  code: string;
  school_type: string;
  grade_levels: string;
  district_id: number;
  principal?: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  zip_code?: string;
  website?: string;
  student_count?: number;
  teacher_count?: number;
  created_at: string;
  updated_at: string;
  district?: {
    id: number;
    name: string;
    code: string;
    state: string;
    country: string;
  };
  user_count?: number;
}

export interface SchoolsListParams {
  skip?: number;
  limit?: number;
  search?: string;
  district_id?: number;
}

export type SchoolsResponse = PaginatedResponse<School>

export const getSchools = async (params: SchoolsListParams = {}): Promise<SchoolsResponse> => {
  const searchParams = new URLSearchParams();
  
  if (params.skip !== undefined) searchParams.append('skip', params.skip.toString());
  if (params.limit !== undefined) searchParams.append('limit', params.limit.toString());
  if (params.search) searchParams.append('search', params.search);
  if (params.district_id) searchParams.append('district_id', params.district_id.toString());
  
  const queryString = searchParams.toString();
  const endpoint = queryString ? `${API_ENDPOINTS.SCHOOLS.LIST}?${queryString}` : API_ENDPOINTS.SCHOOLS.LIST;
  
  return get<SchoolsResponse>(endpoint);
};

export const getSchoolById = async (id: number): Promise<School> => {
  return get<School>(API_ENDPOINTS.SCHOOLS.UPDATE(id.toString()));
};

export const createSchool = async (data: SchoolCreateFormData): Promise<School> => {
  return post<School>(API_ENDPOINTS.SCHOOLS.CREATE, data);
};

export const updateSchool = async (id: number, data: SchoolUpdateFormData): Promise<School> => {
  return put<School>(API_ENDPOINTS.SCHOOLS.UPDATE(id.toString()), data);
};

export const deleteSchool = async (id: number): Promise<void> => {
  return del<void>(API_ENDPOINTS.SCHOOLS.DELETE(id.toString()));
};
